export default __webpack_public_path__ + "d11.png";